import type { PathParams } from "@constellation-academy/epic-ui";
import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import type { levelDefinitionEditScreen_Query } from "@relay/levelDefinitionEditScreen_Query.graphql";
import { QUERY } from "./level-definition-edit.graphql";
import { LevelDefintionForm } from "./parts/level-definition-form";
import { BaseScreen } from "../../components/base-screen";
import { H1Span, H4Span } from "../../themes/font-tags";
import { LevelDefinitionPath } from "../level-definition/level-definition.paths";

export const LevelDefinitionEditScreen = () => {
	const { t } = useTranslation("common");
	const { levelId } = useParams<PathParams<typeof LevelDefinitionPath>>();

	const query = useLazyLoadQuery<levelDefinitionEditScreen_Query>(QUERY, {
		id: levelId!,
		skip: !levelId,
	});

	if (!query.node) {
		return (
			<H4Span>
				{t("levelDefinition.loadError")}
				<br />
				<code>Level-ID: {levelId}</code>
			</H4Span>
		);
	}

	return (
		<BaseScreen>
			<H1Span>{t("levelDefinition.editTitle", { title: query.node.title })}</H1Span>
			<Suspense fallback={<ProgressSpinner />}>
				<LevelDefintionForm levelDefinitionFragmentRef={query.node} />
			</Suspense>
		</BaseScreen>
	);
};
